/**
 * Normalize a document identifier regardless of the shape the wire returns it
 * in: a raw string, a MongoDB Extended-JSON ObjectId (`{ $oid }`), or a plain
 * `id` field.
 *
 * This lives at the boundary with the transport rather than in a host's utils
 * folder, because which of those three shapes arrives is a fact about the wire
 * and about nothing else. Eight modules in the mobile portal imported it; a
 * second surface would have imported its own.
 *
 * @param {{ _id?: string | { $oid?: string }, id?: string } | null | undefined} doc
 * @returns {string | null}
 */
export const idOf = (doc) =>
    typeof doc?._id === 'string' ? doc._id : (doc?._id?.$oid ?? doc?.id ?? null);

export default idOf;
